import React from "react";
import {Outlet} from "react-router-dom";

function MessagingLayout() {
  return <Outlet />;
}

export default MessagingLayout;
